import { toString, Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, unit_type, class_type, record_type, lambda_type, option_type, string_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { loadAllDataSetTranslationsByKey, loadAllDataSets, transformData, loadDataSetTranslationsBySetId, loadMetaData as loadMetaData_1, loadData as loadData_1, DataType, PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A, Filters$reflection, ChartData$reflection } from "../../Api/DataSet.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { length, sortByDescending, tryLast, tryFindIndex, mapIndexed, choose, isEmpty, empty as empty_3, head, tryFind as tryFind_1, filter as filter_1, sortBy, cons, unfold, toArray, map as map_1, ofArray, singleton, append } from "../../fable_modules/fable-library.3.7.20/List.js";
import { split, isNullOrWhiteSpace, printf, toText, join } from "../../fable_modules/fable-library.3.7.20/String.js";
import { map } from "../../fable_modules/fable-library.3.7.20/Array.js";
import { stringHash, compareArrays, equals, partialApply, comparePrimitives, uncurry, createObj, int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { Interop_reactApi } from "../../fable_modules/Feliz.1.68.0/Interop.fs.js";
import { ComposedChart, Bar, Line, Legend, Tooltip, YAxis, XAxis, CartesianGrid } from "recharts";
import { Page, Page$reflection, getActiveFilterParamNames, hardCodedFilterParamNames, periodToFilterId, periodFromFilterId, contractTypeFilterId, getChartTitleKey, getChartSerieTitleKey, getSeriesIndex } from "./Model.js";
import { toArray as toArray_1, bind, map as map_3, flatten, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { info, error } from "../../Components/Message/Message.js";
import { Interop_reactApi as Interop_reactApi_1 } from "../../fable_modules/Feliz.1.68.0/Interop.fs.js";
import { formatUrl, Locale_get_FromSelectedLanguage, truncateString, containsHtmlTags, truncateWithEllipsis, DateTimeExtensions_toDateHHmmss, DateOnlyExtensions_toDate, stackClasses, Result_toBool, Map_merge, Map_mergeWith, logei, Locale$reflection, DateTimeExtensions_toLongMonth, DateTimeExtensions_to1stInMonth, DateTimeExtensions_yyyy_MM_dd, parseQueryParams, optToStr } from "../../Utils.js";
import * as react from "react";
import { LoadState_zip, getEffectDispose, LoadState$2, getTranslationFrom, GlobalDependencies$reflection } from "../../Global.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { forAll, FSharpMap__ContainsKey, ofList, iterate, toList as toList_1, tryFind, FSharpMap__Add, filter, map as map_2, empty as empty_1, FSharpMap__TryFind } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { fold, FSharpSet__Contains, ofArray as ofArray_1, empty } from "../../fable_modules/fable-library.3.7.20/Set.js";
import { loadContractTypesThunk } from "../../Api/Contract.js";
import { year, compare, addMonths, now } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { enGB } from "date-fns/locale";
import { SelectOptionProps, SelectOptionProps_get_GetDefault, SelectOption } from "../../Components/StatefulFormFields/SelectOption.js";
import { iterate as iterate_1, empty as empty_2, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { IconProps, MaterialIcon_render_Z132847CC, Size, MaterialIconBall_render_Z4D0A3336, dotsLoading } from "../../ViewUtils.js";
import { SelectOption as SelectOption_1, ValueProp, SelectOption_get_getDefault, selectOption, CheckboxInput, CheckboxInput_get_getDefault, inputCheckbox } from "../../Components/FormFields/FormFields.js";
import { Browser_Types_Event__Event_get_Value, Browser_Types_Event__Event_get_Checked } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { DropdownProps, DropdownProps_get_GetDefault, Dropdown } from "../../Components/StatefulFormFields/Dropdown.js";
import { DropDownButtonProps, DropDownButtonProps_get_GetDefault, dropDownButton, ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { setItem, getItem } from "../../LocalStorage.js";
import { startImmediate, createCancellationToken, cancel } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { flip } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Tools.fs.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { queryString } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Http.fs.js";
import { ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { Markdown_ToHtml_Z3EA62BCD } from "../../fable_modules/Fable.Formatting.Markdown.1.0.1/Markdown.fs.js";
import { Prop, HTMLAttr, DOMAttr, DangerousHtml } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { isOnlyNumbers, isSQLBoolean, is_yyyy_mm_dd_hh_mm_ss, is_yyyy_mm_dd, isOnlyNumberWithPossibleDecimals } from "../../Validation/Common.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { primary } from "../../Components/Panel/Panel.js";
import { Elements_renderCell, renderCell as renderCell_1, renderCustomTable, renderHeader } from "../../Components/Table/Table.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { AdminModeProps, renderAdminMode } from "./AdminMode.js";
import { loadSessionContextThunk } from "../../Api/Global.js";
import { RouterModule_encodeParts, RouterModule_urlSegments } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import "../../../src/Containers/Reports/View.scss";


const moduleName = "Reports";

export class ChartProps extends Record {
    constructor(ChartIndex, ChartData, GetReportTranslationFn) {
        super();
        this.ChartIndex = (ChartIndex | 0);
        this.ChartData = ChartData;
        this.GetReportTranslationFn = GetReportTranslationFn;
    }
}

export function ChartProps$reflection() {
    return record_type("Containers.Reports.View.ChartProps", [], ChartProps, () => [["ChartIndex", int32_type], ["ChartData", ChartData$reflection()], ["GetReportTranslationFn", lambda_type(string_type, option_type(string_type))]]);
}

export const renderChart = FunctionComponent_Of_Z5A158BBF((props) => {
    let properties_2, properties_4, properties_5, properties_6, matchValue_1, x_1_1, y_1;
    const colors = ["#0bb4ff", "#ffa300", "#9b19f5", "#50e991", "#e60049", "#d0f400", "#FF00BD", "#b3d4ff", "#00bfa0"];
    const yAxisLeftId = "left";
    const chartWidthPx = 830;
    const tooltipXPos = (chartWidthPx - 150) | 0;
    const yAxisOrientation = (orientation) => ["orientation", orientation];
    let children;
    const elements = append(ofArray([(properties_2 = singleton(["strokeDasharray", join(" ", map(int32ToString, new Int32Array([3, 3])))]), Interop_reactApi.createElement(CartesianGrid, createObj(properties_2))), Interop_reactApi.createElement(XAxis, {
        height: 40,
        dataKey: "x",
    }), (properties_4 = ofArray([["yAxisId", yAxisLeftId], ["width", 80], yAxisOrientation("left")]), Interop_reactApi.createElement(YAxis, createObj(properties_4))), (properties_5 = ofArray([["yAxisId", "right"], ["width", 80], yAxisOrientation("right")]), Interop_reactApi.createElement(YAxis, createObj(properties_5))), (properties_6 = singleton(["position", (matchValue_1 = [tooltipXPos, 0], (matchValue_1[0] != null) ? ((matchValue_1[1] != null) ? ((x_1_1 = (matchValue_1[0] | 0), (y_1 = (matchValue_1[1] | 0), {
        x: x_1_1,
        y: y_1,
    }))) : {
        x: 0,
        y: 0,
    }) : ((matchValue_1[1] != null) ? {
        x: 0,
        y: 0,
    } : {
        x: 0,
        y: 0,
    }))]), Interop_reactApi.createElement(Tooltip, createObj(properties_6))), Interop_reactApi.createElement(Legend, {
        verticalAlign: "top",
    })]), map_1((serie) => {
        const serieIndex = getSeriesIndex(serie.DataKey) | 0;
        const seriesTitle = defaultArg(props.GetReportTranslationFn(getChartSerieTitleKey(props.ChartIndex, serieIndex)), serie.Title);
        const matchValue = serie.Type;
        switch (matchValue) {
            case "line": {
                const properties = ofArray([["dataKey", serie.DataKey], ["name", seriesTitle], ["stroke", colors[serieIndex % colors.length]], ["yAxisId", defaultArg(serie.Axis, yAxisLeftId)]]);
                return Interop_reactApi.createElement(Line, createObj(properties));
            }
            case "bar": {
                const properties_1 = ofArray([["dataKey", serie.DataKey], ["name", seriesTitle], ["fill", colors[serieIndex % colors.length]], ["yAxisId", defaultArg(serie.Axis, yAxisLeftId)]]);
                return Interop_reactApi.createElement(Bar, createObj(properties_1));
            }
            default: {
                return error(toText(printf("Unable to render a chart of type \u0027%s\u0027."))(matchValue).split(""));
            }
        }
    }, props.ChartData.Series));
    children = ["children", Interop_reactApi_1.Children.toArray(Array.from(elements))];
    let composedChartHtml;
    const properties_8 = ofArray([["data", toArray(props.ChartData.Data)], ["margin", {
        top: defaultArg(5, 0),
        right: defaultArg(120, 0),
        left: defaultArg(void 0, 0),
        bottom: defaultArg(void 0, 0),
    }], ["width", chartWidthPx], ["height", 300], children]);
    composedChartHtml = Interop_reactApi.createElement(ComposedChart, createObj(properties_8));
    const chartTitle = defaultArg(props.GetReportTranslationFn(getChartTitleKey(props.ChartIndex)), optToStr(props.ChartData.Title));
    const children_3 = [react.createElement("h3", {}, chartTitle), composedChartHtml];
    return react.createElement("div", {
        className: "charts__chart-container",
    }, ...children_3);
}, "Chart", uncurry(2, void 0), void 0, "renderChart", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Reports\\View.fs", 122);

class FilterSectionProps extends Record {
    constructor(GlobalDependencies, Filters, OnApplyFilterClick) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.Filters = Filters;
        this.OnApplyFilterClick = OnApplyFilterClick;
    }
}

function FilterSectionProps$reflection() {
    return record_type("Containers.Reports.View.FilterSectionProps", [], FilterSectionProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["Filters", Filters$reflection()], ["OnApplyFilterClick", lambda_type(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, string_type]), unit_type)]]);
}

const renderFilterSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_14, children_12;
    const contractTypesLoadState = useSelector((state) => state.Contract.ContractTypes);
    const reduxDispatch = useDispatch();
    const queryParamsFromUrl = parseQueryParams(window.location.href);
    let checkedContractTypeCodes;
    const matchValue = FSharpMap__TryFind(queryParamsFromUrl, contractTypeFilterId);
    if (matchValue != null) {
        const contractTypeCodesStr = matchValue;
        checkedContractTypeCodes = (isNullOrWhiteSpace(contractTypeCodesStr) ? empty({
            Compare: comparePrimitives,
        }) : ofArray_1(split(contractTypeCodesStr, [","], null, 0), {
            Compare: comparePrimitives,
        }));
    }
    else {
        checkedContractTypeCodes = empty({
            Compare: comparePrimitives,
        });
    }
    const selectAllOptionState = react.useState(false);
    const selectedContractTypesState = react.useState(empty_1());
    react.useEffect(() => {
        const arg = (contractTypesLoadState.tag === 0) ? empty_1() : ((contractTypesLoadState.tag === 3) ? empty_1() : ((contractTypesLoadState.tag === 1) ? empty_1() : map_2((contractTypeCode, contractType) => FSharpSet__Contains(checkedContractTypeCodes, contractTypeCode), contractTypesLoadState.fields[0])));
        selectedContractTypesState[1](arg);
    }, [contractTypesLoadState]);
    let selectedPeriodFromState;
    let arg_1;
    const matchValue_5 = FSharpMap__TryFind(queryParamsFromUrl, periodFromFilterId);
    arg_1 = ((matchValue_5 == null) ? PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A(props.Filters.PeriodFrom) : matchValue_5);
    selectedPeriodFromState = react.useState(arg_1);
    let selectedPeriodToState;
    let arg_2;
    const matchValue_6 = FSharpMap__TryFind(queryParamsFromUrl, periodToFilterId);
    arg_2 = ((matchValue_6 == null) ? PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A(props.Filters.PeriodTo) : matchValue_6);
    selectedPeriodToState = react.useState(arg_2);
    react.useEffect(() => {
        const filters = props.Filters;
        if (filters.ContractType.IsActive) {
            switch (contractTypesLoadState.tag) {
                case 3: {
                    reduxDispatch(loadContractTypesThunk(props.GlobalDependencies.ClientNr, false));
                    break;
                }
                case 1:
                case 2: {
                    break;
                }
                default: {
                    reduxDispatch(loadContractTypesThunk(props.GlobalDependencies.ClientNr, false));
                }
            }
        }
        let pattern_matching_result;
        if (filters.PeriodFrom.IsActive) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 0;
        }
        switch (pattern_matching_result) {
        }
        let pattern_matching_result_1;
        if (filters.PeriodFrom.IsActive) {
            pattern_matching_result_1 = 0;
        }
        else {
            pattern_matching_result_1 = 0;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                break;
            }
        }
    }, [props.GlobalDependencies]);
    const renderPeriodFilter = (pf, stateHook, label) => {
        let inputRecord_3;
        let options;
        let dateFrom;
        let copyOfStruct = now();
        dateFrom = addMonths(copyOfStruct, pf.MonthsFrom);
        let dateTo;
        let copyOfStruct_1 = now();
        dateTo = addMonths(copyOfStruct_1, pf.MonthsTo);
        const dateOptions = unfold((currentDate) => {
            let dateStr, arg_5, arg_4;
            if (compare(currentDate, dateTo) > 0) {
                return void 0;
            }
            else {
                return [[DateTimeExtensions_yyyy_MM_dd(DateTimeExtensions_to1stInMonth(currentDate)), (dateStr = ((arg_5 = DateTimeExtensions_toLongMonth(enGB, currentDate), (arg_4 = (year(currentDate) | 0), toText(printf("%i %s"))(arg_4)(arg_5)))), react.createElement("div", {
                    className: "filters__period-option",
                }, dateStr))], addMonths(currentDate, 1)];
            }
        }, dateFrom);
        options = cons(["", react.createElement("div", {
            className: "filters__period-option",
        }, "Select date")], dateOptions);
        return SelectOption((inputRecord_3 = SelectOptionProps_get_GetDefault(), new SelectOptionProps(stateHook[0], options, (arg_6) => {
            stateHook[1](arg_6);
        }, label, inputRecord_3.ScrollHeightPx)));
    };
    const hasActiveFilters = (props.Filters.ContractType.IsActive ? true : props.Filters.PeriodFrom.IsActive) ? true : props.Filters.PeriodTo.IsActive;
    if (hasActiveFilters) {
        const children_16 = [react.createElement("h4", {
            className: "filter-container__header",
        }, "Filter"), (children_14 = [(children_12 = toList(delay(() => {
            let ctLoadState, contractTypesMap_1, valueAndDisplay, choooseAllOption, children_3, inputRecord_1, Id_1, inputRecord_2;
            return append_1(props.Filters.ContractType.IsActive ? singleton_1((ctLoadState = contractTypesLoadState, (ctLoadState.tag === 1) ? dotsLoading : ((ctLoadState.tag === 3) ? error(ctLoadState.fields[0].split("")) : ((ctLoadState.tag === 2) ? ((contractTypesMap_1 = filter((_arg, contractType_1) => {
                const matchValue_7 = props.Filters.ContractType.Presentation;
                switch (matchValue_7.tag) {
                    case 1: {
                        return contractType_1.Active;
                    }
                    case 2: {
                        return !contractType_1.Active;
                    }
                    default: {
                        return true;
                    }
                }
            }, ctLoadState.fields[0]), (valueAndDisplay = map_1((tupledArg_1) => {
                let ct, children_1, inputRecord, Id;
                return [tupledArg_1[0], (ct = tupledArg_1[1], (children_1 = [inputCheckbox((inputRecord = CheckboxInput_get_getDefault(), (Id = toText(printf("report-filter-select-contracttypecode-%s"))(ct.ContractTypeCode), new CheckboxInput(inputRecord.Disabled, ct.Display, (e) => {
                    selectedContractTypesState[1]((x_6) => FSharpMap__Add(x_6, ct.ContractTypeCode, Browser_Types_Event__Event_get_Checked(e)));
                }, defaultArg(tryFind(ct.ContractTypeCode, selectedContractTypesState[0]), false), Id, inputRecord.HTMLProps))))], react.createElement("div", {
                    className: "filters__contracttype-checkbox",
                }, ...children_1)))];
            }, sortBy((tupledArg) => tupledArg[1].Display, toList_1(contractTypesMap_1), {
                Compare: comparePrimitives,
            })), (choooseAllOption = ["", (children_3 = [inputCheckbox((inputRecord_1 = CheckboxInput_get_getDefault(), (Id_1 = toText(printf("report-filter-select-contracttypecode-choose-all")), new CheckboxInput(inputRecord_1.Disabled, "Choose all", (e_1) => {
                selectAllOptionState[1](Browser_Types_Event__Event_get_Checked(e_1));
                iterate((contractTypeCode_3, _arg_1) => {
                    selectedContractTypesState[1]((x_8) => FSharpMap__Add(x_8, contractTypeCode_3, Browser_Types_Event__Event_get_Checked(e_1)));
                }, contractTypesMap_1);
            }, selectAllOptionState[0], Id_1, inputRecord_1.HTMLProps))))], react.createElement("div", {
                className: "filters__contracttype-checkbox filters__contracttype-checkbox--choose-all",
            }, ...children_3))], Dropdown((inputRecord_2 = DropdownProps_get_GetDefault(), new DropdownProps(cons(choooseAllOption, valueAndDisplay), "Contract Type", "Select", (value_1) => {
            }, "400px"))))))) : react.createElement(react.Fragment, {}))))) : empty_2(), delay(() => append_1(props.Filters.PeriodFrom.IsActive ? singleton_1(renderPeriodFilter(props.Filters.PeriodFrom, selectedPeriodFromState, "Period from")) : empty_2(), delay(() => (props.Filters.PeriodTo.IsActive ? singleton_1(renderPeriodFilter(props.Filters.PeriodTo, selectedPeriodToState, "Period to")) : empty_2())))));
        })), react.createElement("div", {
            className: "filters__list",
        }, ...children_12)), wrappedButton(new ButtonKind(0), new ButtonProps("Apply filter", defaultProps.Content, (_arg_2) => {
            let contractTypeCodes, periodFrom, periodTo;
            props.OnApplyFilterClick((contractTypeCodes = [contractTypeFilterId, join(",", map_1((tuple_1) => tuple_1[0], filter_1((tuple) => tuple[1], toList_1(selectedContractTypesState[0]))))], (periodFrom = [periodFromFilterId, selectedPeriodFromState[0]], (periodTo = [periodToFilterId, selectedPeriodToState[0]], ofList(toList(delay(() => append_1(props.Filters.ContractType.IsActive ? singleton_1(contractTypeCodes) : empty_2(), delay(() => append_1(props.Filters.PeriodFrom.IsActive ? singleton_1(periodFrom) : empty_2(), delay(() => (props.Filters.PeriodTo.IsActive ? singleton_1(periodTo) : empty_2()))))))))))));
        }, defaultProps.Disabled, "apply-filter-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))], react.createElement("div", {
            className: "filters-container__filters",
        }, ...children_14))];
        return react.createElement("div", {
            className: "report__filters-container",
        }, ...children_16);
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, void 0, uncurry(2, void 0), void 0, "renderFilterSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Reports\\View.fs", 365);

class DownloadFormat extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Excel", "CSV", "Slk"];
    }
}

function DownloadFormat$reflection() {
    return union_type("Containers.Reports.View.DownloadFormat", [], DownloadFormat, () => [[], [], []]);
}

function DownloadFormat_get_toPartialUrl() {
    return (_arg) => ((_arg.tag === 1) ? "DataCsv" : ((_arg.tag === 2) ? "DataSlk" : "DataExcel"));
}

function DownloadFormat_get_toString() {
    return (_arg) => ((_arg.tag === 1) ? "CSV" : ((_arg.tag === 2) ? "Slk" : "Excel"));
}

class SpecificReportProps extends Record {
    constructor(GlobalDependencies, SetId, Locale) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.SetId = SetId;
        this.Locale = Locale;
    }
}

function SpecificReportProps$reflection() {
    return record_type("Containers.Reports.View.SpecificReportProps", [], SpecificReportProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["SetId", string_type], ["Locale", Locale$reflection()]]);
}

const renderSpecificReport = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_32, inputRecord_1, children_45, inputRecord_2, children_49;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reportTranslationsState = react.useState(new LoadState$2(0));
    const getReportTranslation = (translationKey) => {
        const matchValue = reportTranslationsState[0];
        if (matchValue.tag === 2) {
            return flatten(tryFind(translationKey, matchValue.fields[0]));
        }
        else {
            return void 0;
        }
    };
    const isAdminModeState = react.useState(false);
    const setIdState = react.useState(props.SetId);
    react.useEffect(() => {
        setIdState[1](props.SetId);
    }, [props.SetId]);
    const pendingRequestRef = react.useRef(void 0);
    const pageSizes = ofArray([["10", "10"], ["20", "20"], ["50", "50"], ["100", "100"]]);
    const pageSizeLocalStorageKey = "PageSize";
    let pageSizeState;
    const arg = defaultArg(map_3((tuple) => tuple[0], bind((localStorageValue) => tryFind_1((tupledArg) => (tupledArg[0] === localStorageValue), pageSizes), getItem(moduleName, pageSizeLocalStorageKey))), head(pageSizes)[0]);
    pageSizeState = react.useState(arg);
    react.useEffect(() => {
        setItem(moduleName, pageSizeLocalStorageKey, pageSizeState[0]);
    }, [pageSizeState[0]]);
    const readQueryParamsFromUrl = () => map_2((name, value_2) => [value_2, new DataType(0)], parseQueryParams(window.location.href));
    const providedQueryParamsState = react.useState(readQueryParamsFromUrl());
    const userProvidedParamsState = react.useState(empty_3());
    const metaDataState = react.useState(new LoadState$2(0));
    const dataState = react.useState(new LoadState$2(0));
    const getQueryParametersToBeSent = () => map_2((paramName, tupledArg_1) => tupledArg_1[0], providedQueryParamsState[0]);
    const getParamsForUserToFill = (missingParams, providedParams) => filter_1((tupledArg_2) => {
        const name_1 = tupledArg_2[0];
        if (!FSharpMap__ContainsKey(providedParams, name_1)) {
            return !FSharpSet__Contains(hardCodedFilterParamNames, name_1);
        }
        else {
            return false;
        }
    }, missingParams);
    const loadData = (metaDataLoadState, urlQueryParams) => {
        iterate_1((cts) => {
            cancel(cts);
        }, toArray_1(pendingRequestRef.current));
        const newCTS = createCancellationToken();
        pendingRequestRef.current = newCTS;
        dataState[1](new LoadState$2(1));
        const urlQueryParamsWithFilterParams = (metaDataLoadState.tag === 2) ? fold((x, y) => flip((paramId, urlParams) => {
            if (FSharpMap__ContainsKey(urlParams, paramId)) {
                return urlParams;
            }
            else {
                return FSharpMap__Add(urlParams, paramId, "");
            }
        }, x, y), urlQueryParams, getActiveFilterParamNames(metaDataLoadState.fields[0].Filters)) : urlQueryParams;
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadData_1(props.GlobalDependencies.ClientNr, props.SetId, urlQueryParamsWithFilterParams), (_arg_1) => {
            const dataResult = _arg_1;
            let arg_4;
            if (dataResult.tag === 0) {
                arg_4 = (new LoadState$2(2, dataResult.fields[0]));
            }
            else {
                const msg_1 = dataResult.fields[0];
                logei(msg_1);
                arg_4 = (new LoadState$2(3, msg_1));
            }
            dataState[1](arg_4);
            return singleton_2.Zero();
        })), newCTS);
    };
    react.useEffect(() => {
        const disp = (() => {
        iterate_1((cts_1) => {
            cancel(cts_1);
        }, toArray_1(pendingRequestRef.current));
        const newCTS_1 = createCancellationToken();
        pendingRequestRef.current = newCTS_1;
        dataState[1](new LoadState$2(0));
        metaDataState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadMetaData_1(props.GlobalDependencies.ClientNr, props.SetId), (_arg_2) => {
            const metaDataResult = _arg_2;
            let arg_5;
            if (metaDataResult.tag === 0) {
                const metaData_1 = metaDataResult.fields[0];
                let filterDefaultValuesParams;
                const filtersOpt = metaData_1.Filters;
                if (filtersOpt != null) {
                    const filters = filtersOpt;
                    filterDefaultValuesParams = ofList(toList(delay(() => {
                        let matchValue_2;
                        return append_1((matchValue_2 = [filters.PeriodFrom.IsActive, filters.PeriodFrom.DefaultValue], matchValue_2[0] ? ((matchValue_2[1] != null) ? singleton_1([periodFromFilterId, PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A(filters.PeriodFrom)]) : ((empty_2()))) : ((empty_2()))), delay(() => {
                            const matchValue_3 = [filters.PeriodTo.IsActive, filters.PeriodTo.DefaultValue];
                            let pattern_matching_result;
                            if (matchValue_3[0]) {
                                if (matchValue_3[1] != null) {
                                    pattern_matching_result = 0;
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                            switch (pattern_matching_result) {
                                case 0: {
                                    return singleton_1([periodToFilterId, PeriodFilter_GetDefaultValueAsParamValue_1DF1F64A(filters.PeriodTo)]);
                                }
                                case 1: {
                                    return empty_2();
                                }
                            }
                        }));
                    })));
                }
                else {
                    filterDefaultValuesParams = empty_1();
                }
                if (isEmpty(metaData_1.MissingParameters)) {
                    loadData(new LoadState$2(2, metaData_1), filterDefaultValuesParams);
                }
                else {
                    const providedQueryParams = Map_mergeWith(Map_merge(readQueryParamsFromUrl(), providedQueryParamsState[0]), map_2((key_1, value_5) => [value_5, new DataType(0)], filterDefaultValuesParams), (key_2, tupledArg_3) => {
                        const provided = tupledArg_3[0];
                        const filterDefault = tupledArg_3[1];
                        const matchValue_5 = [provided[0], filterDefault[0]];
                        return (matchValue_5[0] === "") ? filterDefault : ((matchValue_5[1] === "") ? provided : provided);
                    });
                    providedQueryParamsState[1](providedQueryParams);
                    const remainingParams = getParamsForUserToFill(metaData_1.MissingParameters, providedQueryParams);
                    userProvidedParamsState[1](remainingParams);
                    const matchValue_6 = isEmpty(remainingParams);
                    if (matchValue_6) {
                        loadData(new LoadState$2(2, metaData_1), Map_merge(filterDefaultValuesParams, map_2((paramName_1, tupledArg_4) => tupledArg_4[0], providedQueryParams)));
                    }
                }
                arg_5 = (new LoadState$2(2, metaData_1));
            }
            else {
                const msg_2 = metaDataResult.fields[0];
                logei(msg_2);
                arg_5 = (new LoadState$2(3, msg_2));
            }
            metaDataState[1](arg_5);
            return singleton_2.Zero();
        })), newCTS_1);
        reportTranslationsState[1](new LoadState$2(1));
        startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadDataSetTranslationsBySetId(props.GlobalDependencies.SelectedLanguage, props.SetId), (_arg) => {
            const result = _arg;
            const arg_2 = (result.tag === 0) ? (new LoadState$2(2, ofList(map_1((dto) => [dto.Key, dto.Translation], result.fields[0])))) : (new LoadState$2(3, result.fields[0]));
            reportTranslationsState[1](arg_2);
            return singleton_2.Zero();
        })));
        return getEffectDispose(() => {
            iterate_1((cts_2) => {
                cancel(cts_2);
            }, toArray_1(pendingRequestRef.current));
        });
    })();
        return () => disp.Dispose();
    }, [props.GlobalDependencies, props.SetId]);
    const getDownloadButtonPropsOpt = (dlFormat) => {
        let Id;
        const partialUrl = DownloadFormat_get_toPartialUrl()(dlFormat);
        const urlParams_1 = queryString(getQueryParametersToBeSent());
        const matchValue_7 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/SYSTEM/DataSet2/%i/%s/%s/%s"))(props.GlobalDependencies.ClientNr)(props.SetId)(partialUrl)(urlParams_1)));
        if (matchValue_7.tag === 0) {
            const validatedUrl_1 = ValidatedUrl__get_Value(matchValue_7.fields[0]);
            const partialId = DownloadFormat_get_toString()(dlFormat).toLocaleLowerCase();
            return (Id = toText(printf("report-download-%s"))(partialId), new ButtonProps(DownloadFormat_get_toString()(dlFormat), defaultProps.Content, (_arg_3) => {
                window.location.href = validatedUrl_1;
            }, defaultProps.Disabled, Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
        }
        else {
            logei(matchValue_7.fields[0]);
            return void 0;
        }
    };
    const downloadButtonsProps = choose((x_1) => x_1, ofArray([getDownloadButtonPropsOpt(new DownloadFormat(0)), getDownloadButtonPropsOpt(new DownloadFormat(1)), getDownloadButtonPropsOpt(new DownloadFormat(2))]));
    const adminEditIconHtml = props.GlobalDependencies.IsAdminUser ? MaterialIconBall_render_Z4D0A3336("edit", new Size(2), (_arg_4) => {
        isAdminModeState[1](true);
    }) : react.createElement(react.Fragment, {});
    let metaDataHtml;
    const matchValue_14 = LoadState_zip(metaDataState[0], reportTranslationsState[0]);
    switch (matchValue_14.tag) {
        case 1: {
            metaDataHtml = dotsLoading;
            break;
        }
        case 3: {
            metaDataHtml = error(matchValue_14.fields[0].split(""));
            break;
        }
        case 2: {
            const metaData_2 = matchValue_14.fields[0][0];
            let descriptionMarkdownHtml;
            const props_17 = [new DOMAttr(0, new DangerousHtml(Markdown_ToHtml_Z3EA62BCD(defaultArg(getReportTranslation("Description"), metaData_2.Description))))];
            descriptionMarkdownHtml = react.createElement("div", keyValueList(props_17, 1));
            const validationFn = (dataType_3, str) => {
                switch (dataType_3.tag) {
                    case 4: {
                        return isOnlyNumberWithPossibleDecimals(getTranslation, str);
                    }
                    case 1: {
                        return is_yyyy_mm_dd(getTranslation, str);
                    }
                    case 2: {
                        return is_yyyy_mm_dd_hh_mm_ss(getTranslation, str);
                    }
                    case 5: {
                        return isSQLBoolean(getTranslation, str);
                    }
                    case 0:
                    case 6:
                    case 7: {
                        return new FSharpResult$2(0, str);
                    }
                    default: {
                        return isOnlyNumbers(getTranslation, str);
                    }
                }
            };
            let allParametersAreValid;
            const matchValue_15 = isEmpty(getParamsForUserToFill(metaData_2.MissingParameters, providedQueryParamsState[0]));
            allParametersAreValid = (matchValue_15 && forAll((key_3, tupledArg_5) => Result_toBool(validationFn(tupledArg_5[1], tupledArg_5[0])), providedQueryParamsState[0]));
            let inputMissingParametersHtml;
            const onSearchClick = (_arg_6) => {
                loadData(metaDataState[0], getQueryParametersToBeSent());
            };
            const missingWithoutFilters = filter_1((tupledArg_6) => (!FSharpSet__Contains(hardCodedFilterParamNames, tupledArg_6[0])), metaData_2.MissingParameters);
            let bodyHtml;
            let paramsHtml;
            const children_20 = map_1((userProvidedParam) => {
                let inputRecord;
                const valueStr = userProvidedParam[0];
                const dataType_4 = userProvidedParam[1];
                const id = toText(printf("input-parameter-%s"))(valueStr);
                const valueTypeTupleOpt = FSharpMap__TryFind(providedQueryParamsState[0], valueStr);
                const props_19 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "mt-2"])))];
                const children_18 = [render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1(optToStr(map_3((tuple_1) => tuple_1[0], valueTypeTupleOpt)), inputRecord.Type, inputRecord.Classes, (e_1) => {
                    providedQueryParamsState[1]((x_2) => FSharpMap__Add(x_2, valueStr, [Browser_Types_Event__Event_get_Value(e_1), dataType_4]));
                }, inputRecord.Disabled, valueStr, id, partialApply(1, validationFn, [dataType_4]), inputRecord.DynamicWidth, singleton(new DOMAttr(17, (e) => {
                    if ((e.key === "Enter") && allParametersAreValid) {
                        onSearchClick();
                    }
                })), inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))];
                return react.createElement("div", keyValueList(props_19, 1), ...children_18);
            }, missingWithoutFilters);
            paramsHtml = react.createElement("div", {
                className: "report__parameters",
                id: "report-missing-param-container",
            }, ...children_20);
            const buttonHtml = wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.Search"), defaultProps.Content, onSearchClick, !allParametersAreValid, "report-load-data-with-params-btn", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
            bodyHtml = react.createElement("div", {}, paramsHtml, buttonHtml);
            inputMissingParametersHtml = (isEmpty(missingWithoutFilters) ? react.createElement(react.Fragment, {}) : primary("Parameters", bodyHtml, void 0));
            let chartsHtml_1;
            const matchValue_17 = dataState[0];
            let pattern_matching_result_1, data_2;
            if (matchValue_17.tag === 1) {
                pattern_matching_result_1 = 0;
            }
            else if (matchValue_17.tag === 2) {
                if (!isEmpty(matchValue_17.fields[0].ChartData.ChartData)) {
                    pattern_matching_result_1 = 1;
                    data_2 = matchValue_17.fields[0];
                }
                else {
                    pattern_matching_result_1 = 2;
                }
            }
            else {
                pattern_matching_result_1 = 2;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    chartsHtml_1 = dotsLoading;
                    break;
                }
                case 1: {
                    const chartsHtml = mapIndexed((i, chartData) => renderChart(new ChartProps(i, chartData, getReportTranslation)), data_2.ChartData.ChartData);
                    chartsHtml_1 = react.createElement("div", {
                        className: "reports__charts",
                    }, ...chartsHtml);
                    break;
                }
                case 2: {
                    chartsHtml_1 = react.createElement(react.Fragment, {});
                    break;
                }
            }
            let filtersHtml;
            const matchValue_18 = metaData_2.Filters;
            filtersHtml = ((matchValue_18 != null) ? renderFilterSection(new FilterSectionProps(props.GlobalDependencies, matchValue_18, (filterQueryParams) => {
                const mergedParams = Map_merge(getQueryParametersToBeSent(), filterQueryParams);
                providedQueryParamsState[1]((x_3) => Map_merge(x_3, map_2((key_4, value_7) => [value_7, new DataType(0)], filterQueryParams)));
                loadData(metaDataState[0], mergedParams);
            })) : react.createElement(react.Fragment, {}));
            const translatedTitleStr = defaultArg(getReportTranslation("Title"), defaultArg(metaData_2.Title, props.SetId));
            const children_34 = [(children_32 = [react.createElement("h1", {}, translatedTitleStr)], react.createElement("div", {
                className: "top__admin-edit-icon-container",
            }, ...children_32)), descriptionMarkdownHtml, inputMissingParametersHtml, chartsHtml_1, filtersHtml];
            metaDataHtml = react.createElement("div", {
                className: "report__top",
                id: "report-meta-data",
            }, ...children_34);
            break;
        }
        default: {
            metaDataHtml = react.createElement(react.Fragment, {});
        }
    }
    let dataHtml;
    const matchValue_19 = [metaDataState[0], dataState[0]];
    let pattern_matching_result_2, msg_6, dataV2, metaData_3;
    if (matchValue_19[1].tag === 1) {
        pattern_matching_result_2 = 0;
    }
    else if (matchValue_19[1].tag === 3) {
        pattern_matching_result_2 = 1;
        msg_6 = matchValue_19[1].fields[0];
    }
    else if (matchValue_19[1].tag === 2) {
        if (matchValue_19[0].tag === 2) {
            pattern_matching_result_2 = 2;
            dataV2 = matchValue_19[1].fields[0];
            metaData_3 = matchValue_19[0].fields[0];
        }
        else {
            pattern_matching_result_2 = 3;
        }
    }
    else {
        pattern_matching_result_2 = 3;
    }
    switch (pattern_matching_result_2) {
        case 0: {
            dataHtml = dotsLoading;
            break;
        }
        case 1: {
            if (msg_6 === "DataSet contains no query") {
                logei(msg_6);
                dataHtml = react.createElement(react.Fragment, {});
            }
            else {
                dataHtml = error(msg_6.split(""));
            }
            break;
        }
        case 2: {
            const dropDownButtonHtml = dropDownButton((inputRecord_1 = DropDownButtonProps_get_GetDefault(), new DropDownButtonProps("report-dropdown-save-as", "Save report", downloadButtonsProps)));
            let dataTableHtml;
            const renderedHeaders = map_1(renderHeader, metaData_3.Headers);
            const invoiceeNrHeaderIndexOpt = tryFindIndex((header_1) => (header_1.toLocaleLowerCase() === "invoiceenr"), metaData_3.Headers);
            const children_40 = [Pagination()(new PageinationProps$1((rows) => {
                let invoiceeNrIndex;
                return renderCustomTable(renderedHeaders, map_1((children_37) => react.createElement("tr", {}, ...children_37), map_1((invoiceeNrIndex = invoiceeNrHeaderIndexOpt, (cells) => mapIndexed((index, cell) => {
                    let matchValue_11, textLengthLimit, truncatedText, popUpContent_1, props_9, children_12, contentHtml, input, popUpContent, maxLength, strContent, children_4, matchValue_12;
                    const renderInvoiceeNrAnchor = (content) => {
                        const matchValue_8 = equals(invoiceeNrIndex, index);
                        if (matchValue_8) {
                            let href;
                            const matchValue_9 = ValidatedUrlModule_create(new UrlKind(0, toText(printf("/#/CustomerContract/Invoicee/%s"))(content)));
                            if (matchValue_9.tag === 0) {
                                href = ValidatedUrl__get_Value(matchValue_9.fields[0]);
                            }
                            else {
                                logei(matchValue_9.fields[0]);
                                href = "";
                            }
                            return react.createElement("a", {
                                href: href,
                            }, content);
                        }
                        else {
                            return content;
                        }
                    };
                    switch (cell.tag) {
                        case 1: {
                            return renderCell_1(DateOnlyExtensions_toDate(props.Locale.ILocale, cell.fields[0]));
                        }
                        case 2: {
                            return renderCell_1(DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, cell.fields[0]));
                        }
                        case 3: {
                            return Elements_renderCell(renderInvoiceeNrAnchor(int32ToString(cell.fields[0])));
                        }
                        case 4: {
                            return Elements_renderCell(renderInvoiceeNrAnchor(cell.fields[0].toString()));
                        }
                        case 5: {
                            return renderCell_1(cell.fields[0] ? "✓" : "-");
                        }
                        case 6: {
                            return renderCell_1(truncateWithEllipsis(30, cell.fields[0]));
                        }
                        case 7: {
                            return renderCell_1("");
                        }
                        case 8: {
                            return renderCell_1(toString(cell));
                        }
                        default: {
                            const text = cell.fields[0];
                            return Elements_renderCell((matchValue_11 = containsHtmlTags(text), matchValue_11 ? ((textLengthLimit = 150, (truncatedText = truncateString(textLengthLimit, text), (popUpContent_1 = ((props_9 = [new DOMAttr(0, new DangerousHtml(text)), new HTMLAttr(65, "data-table__popup")], react.createElement("div", keyValueList(props_9, 1)))), (children_12 = toList(delay(() => {
                                let props_11;
                                return append_1(singleton_1((props_11 = [new DOMAttr(0, new DangerousHtml(truncatedText))], react.createElement("div", keyValueList(props_11, 1)))), delay(() => ((text.length > textLengthLimit) ? singleton_1(MaterialIcon_render_Z132847CC(new IconProps(popUpContent_1, "chat"))) : empty_2())));
                            })), react.createElement("div", {
                                className: "d-flex",
                            }, ...children_12)))))) : ((contentHtml = ((input = text, (popUpContent = react.createElement("div", {
                                className: "data-table__popup",
                            }, text), (maxLength = 50, (strContent = truncateWithEllipsis(maxLength, input), (input.length >= maxLength) ? ((children_4 = [react.createElement("span", {
                                className: "mr-2",
                            }, strContent), MaterialIcon_render_Z132847CC(new IconProps(popUpContent, "chat"))], react.createElement("span", {
                                className: "d-flex",
                            }, ...children_4))) : strContent))))), (matchValue_12 = equals(invoiceeNrIndex, index), matchValue_12 ? renderInvoiceeNrAnchor(truncateWithEllipsis(40, text)) : contentHtml)))));
                        }
                    }
                }, cells)), transformData(metaData_3.DataTypes, rows))));
            }, dataV2.TableData, parse(pageSizeState[0], 511, false, 32), 0))];
            dataTableHtml = react.createElement("div", {
                className: "data-container__data-table",
            }, ...children_40);
            const slkOnlyMsgHtml = metaData_3.SlkOnly ? info(getTranslation("Reports.TooBig").split("")) : react.createElement(react.Fragment, {});
            let pageSizesHtml;
            const props_48 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
            const children_47 = [react.createElement("div", {
                className: "mr-2",
            }, "Rows per page"), (children_45 = [selectOption((inputRecord_2 = SelectOption_get_getDefault(), new SelectOption_1(new ValueProp(0, pageSizeState[0], (e_2) => {
                pageSizeState[1](Browser_Types_Event__Event_get_Value(e_2));
            }), "report-page-sizes-select-option", pageSizes, inputRecord_2.Classes, inputRecord_2.LabelText, inputRecord_2.Disabled, inputRecord_2.HTMLProps)))], react.createElement("div", {
                className: "data-container__page-sizes",
            }, ...children_45))];
            pageSizesHtml = react.createElement("div", keyValueList(props_48, 1), ...children_47);
            const children_51 = [(children_49 = toList(delay(() => append_1((!(metaData_3.SlkOnly ? true : isEmpty(dataV2.TableData))) ? singleton_1(pageSizesHtml) : empty_2(), delay(() => singleton_1(dropDownButtonHtml))))), react.createElement("div", {
                className: "reports__container",
            }, ...children_49)), dataTableHtml, slkOnlyMsgHtml];
            dataHtml = react.createElement("div", {
                className: "report__data-container",
            }, ...children_51);
            break;
        }
        case 3: {
            dataHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    const matchValue_21 = isAdminModeState[0];
    if (matchValue_21) {
        const matchValue_22 = metaDataState[0];
        if (matchValue_22.tag === 2) {
            return renderAdminMode(new AdminModeProps(props.GlobalDependencies, props.SetId, matchValue_22.fields[0], () => {
                isAdminModeState[1](false);
            }, () => {
                isAdminModeState[1](false);
                reduxDispatch(loadSessionContextThunk());
            }));
        }
        else {
            return react.createElement(react.Fragment, {});
        }
    }
    else {
        return react.createElement("div", {
            className: "reports__report",
        }, adminEditIconHtml, metaDataHtml, dataHtml);
    }
}, void 0, uncurry(2, void 0), void 0, "renderSpecificReport", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Reports\\View.fs", 945);

export class ReportsProps extends Record {
    constructor(GlobalDependencies, Page) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.Page = Page;
    }
}

export function ReportsProps$reflection() {
    return record_type("Containers.Reports.View.ReportsProps", [], ReportsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["Page", Page$reflection()]]);
}

export const renderReports = FunctionComponent_Of_Z5A158BBF((props) => {
    const allReportsState = react.useState(new LoadState$2(0));
    const titleTranslationsState = react.useState(new LoadState$2(0));
    const locale = Locale_get_FromSelectedLanguage()(props.GlobalDependencies.SelectedLanguage);
    react.useEffect(() => {
        if (equals(props.Page, new Page(0))) {
            allReportsState[1](new LoadState$2(1));
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadAllDataSets(props.GlobalDependencies.ClientNr), (_arg_1) => {
                const result_1 = _arg_1;
                const arg_3 = (result_1.tag === 0) ? (new LoadState$2(2, result_1.fields[0])) : (new LoadState$2(3, result_1.fields[0]));
                allReportsState[1](arg_3);
                return singleton_2.Zero();
            })));
            titleTranslationsState[1](new LoadState$2(1));
            startImmediate(singleton_2.Delay(() => singleton_2.Bind(loadAllDataSetTranslationsByKey(props.GlobalDependencies.SelectedLanguage, "Title"), (_arg) => {
                const result = _arg;
                const arg_1 = (result.tag === 0) ? (new LoadState$2(2, ofList(map_1((trans) => [trans.SetId, trans], result.fields[0])))) : (new LoadState$2(3, result.fields[0]));
                titleTranslationsState[1](arg_1);
                return singleton_2.Zero();
            })));
        }
    }, [props.Page]);
    let reportsHtml;
    const matchValue = LoadState_zip(allReportsState[0], titleTranslationsState[0]);
    switch (matchValue.tag) {
        case 1: {
            reportsHtml = dotsLoading;
            break;
        }
        case 3: {
            reportsHtml = error(matchValue.fields[0].split(""));
            break;
        }
        case 2: {
            const children_11 = map_1((tupledArg) => {
                let children_7;
                const children_9 = [react.createElement("h3", {}, tupledArg[0]), (children_7 = map_1((mini) => {
                    let matchValue_1;
                    let url;
                    const currentUrl = RouterModule_urlSegments(window.location.hash, 1);
                    url = RouterModule_encodeParts(formatUrl(currentUrl, singleton((matchValue_1 = tryLast(currentUrl), (matchValue_1 == null) ? "Reports" : matchValue_1)), singleton(mini.SetId)), 1);
                    const titleTranslation = defaultArg(defaultArg(map_3((trans_1) => trans_1.Translation, tryFind(mini.SetId, matchValue.fields[0][1])), mini.Title), mini.SetId);
                    const children_3 = [react.createElement("a", {
                        href: url,
                    }, titleTranslation)];
                    return react.createElement("li", {}, ...children_3);
                }, tupledArg[1]), react.createElement("ul", {
                    className: "reports__list",
                }, ...children_7))];
                return react.createElement("div", {}, ...children_9);
            }, sortByDescending((tupledArg_2) => length(tupledArg_2[1]), map_1((tupledArg_1) => [tupledArg_1[0], sortBy((ds) => {
                const matchValue_2 = ds.SortOrder;
                if (matchValue_2 == null) {
                    return [2147483647, defaultArg(ds.Title, ds.SetId)];
                }
                else {
                    return [matchValue_2, defaultArg(ds.Title, ds.SetId)];
                }
            }, tupledArg_1[1], {
                Compare: compareArrays,
            })], List_groupBy((report) => report.MenuItem, matchValue.fields[0][0], {
                Equals: (x, y) => (x === y),
                GetHashCode: stringHash,
            })), {
                Compare: comparePrimitives,
            }));
            reportsHtml = react.createElement("div", {
                className: "reports__containers",
            }, ...children_11);
            break;
        }
        default: {
            reportsHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_26 = toList(delay(() => {
        let props_23, children_22, children_20, children_18;
        const matchValue_3 = props.Page;
        switch (matchValue_3.tag) {
            case 1: {
                const setId = matchValue_3.fields[0];
                return singleton_1((props_23 = [new Prop(0, toText(printf("%i-%s"))(props.GlobalDependencies.ClientNr)(setId))], (children_22 = [renderSpecificReport(new SpecificReportProps(props.GlobalDependencies, setId, locale))], react.createElement("div", keyValueList(props_23, 1), ...children_22))));
            }
            case 2: {
                return singleton_1(react.createElement("h3", {}, "Not found"));
            }
            default: {
                return singleton_1((children_20 = [(children_18 = [react.createElement("h2", {}, "Reports"), react.createElement("p", {
                    className: "blockquote-footer",
                }, "List of available reports.")], react.createElement("div", {
                    className: "blockquote",
                }, ...children_18)), reportsHtml], react.createElement("div", {}, ...children_20)));
            }
        }
    }));
    return react.createElement("div", {
        className: "reports",
    }, ...children_26);
}, void 0, uncurry(2, void 0), void 0, "renderReports", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Reports\\View.fs", 1067);

